import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FullScreenLoader } from '../../components';
import { getGoogleAuthURL, getMicrosoftAuthURL, getZohoAuthURL } from '../../utils/helpers';
import * as qs from "qs";

const ConnectInboxScreen = () => {
    const params = useParams();
    const type = params.type;
    const host = params.host;
    const parsedObject = qs.parse(window.location.search?.slice(1));


    useEffect(() => {

        localStorage.setItem('inbox_host', host);
        localStorage.setItem('tenant_path', parsedObject.tenant_path );

        switch (type) {
            case "gmail":
                window.location.href = getGoogleAuthURL(false, false, true);
                break;

            case "outlook":
                window.location.href = getMicrosoftAuthURL(true);
                break;

            case "zoho":
                window.location.href = getZohoAuthURL();
                break;
        }

    }, []);
    return <div>
        <FullScreenLoader />
    </div>
}

export default ConnectInboxScreen;